var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('nav',{staticClass:"component-navbar main-navbar navbar navbar-expand-lg",staticStyle:{"min-height":"82px"}},[_c('div',{staticClass:"container"},[(_vm.userQuizId)?_c('div',{staticStyle:{"color":"gray","margin-top":"auto","margin-bottom":"auto"}},[_vm._v("Уникальный идентификатор прохождения #"+_vm._s(_vm.userQuizId))]):_vm._e()])])])
}
var staticRenderFns = []

export { render, staticRenderFns }